declare namespace $ {

	export class $shm_hitalama_codex_general extends $shm_hitalama_codex_map {
		map_id( ): string
	}
	
}

//# sourceMappingURL=general.view.tree.d.ts.map